"use strict";
exports.__esModule = true;
exports.UUIDs = void 0;
var uuid_1 = require("uuid");
exports.UUIDs = {
    v4: uuid_1.v4
};
//# sourceMappingURL=uuids.js.map